import React from 'react'
import {Route, Switch} from 'react-router-dom';
import RouterPath from 'libs/RouterPath';
import NotFound from '../NotFound/NotFound';
import {withRouter} from "react-router";
import CtrDemand from "./demand/CtrDemand";
import Endpoints from "../../constants/Endpoints";

function ContractorRouter() {

    return (
        <Switch>
            <Route exact path={RouterPath.CTR_INIT} component={() => {
                window.location.replace( Endpoints.SERVER_URL);
                return null;
            }}/>
            <Route path={RouterPath.CTR_DEMAND} component={CtrDemand}/>
            <Route component={NotFound}/>
        </Switch>
    )
}

export default withRouter(ContractorRouter);
